;(function () {
    'use strict';

    ready(function()
    {
        window.highcharts11 = [];
        window.highcharts11Widths = [];
        const chartBlocks = document.querySelectorAll('.js-highcharts');
        chartBlocks.forEach(function(chartBlock)
        {
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ',',
                    decimalPoint: '.',
                    numericSymbols: null,
                },
            });

            const chartElements = chartBlock.querySelectorAll('.js-highcharts-chart');
            chartElements.forEach(function(chartElement)
            {
                const chartOptionsRaw = chartElement.getAttribute('data-highcharts-options');
                const chartOptions = JSON.parse(chartOptionsRaw);

                chartOptions['xAxis'].forEach(function(axis, index) {
                    if ('labels' in chartOptions['xAxis'][index] && 'formatter' in chartOptions['xAxis'][index]['labels'] && chartOptions['xAxis'][index]['labels']['formatter'] === 'thousands-comma') {
                        chartOptions['xAxis'][index]['labels']['formatter'] = function() {
                            return Highcharts.numberFormat(this.value, null, null, ',');
                        }
                    }
                });

                chartOptions['yAxis'].forEach(function(axis, index) {
                    if ('labels' in chartOptions['yAxis'][index] && 'formatter' in chartOptions['yAxis'][index]['labels'] && chartOptions['yAxis'][index]['labels']['formatter'] === 'thousands-comma') {
                        chartOptions['yAxis'][index]['labels']['formatter'] = function() {
                            return Highcharts.numberFormat(this.value, null, null, ',');
                        }
                    }
                });

                console.log(chartOptions);
                let chart = Highcharts.chart(chartElement, chartOptions);

                const switcherSelect = chartBlock.querySelector('.js-highcharts-switcher');
                if (switcherSelect) {
                    switcherSelect.addEventListener('change', function(e) {
                        e.preventDefault();
                        const targetChartID = this.value;
                        const targetChartElement = chartBlock.querySelector('.js-highcharts-chart[data-highcharts-chart-id="' + targetChartID + '"]');
                        const allChartElements = chartBlock.querySelectorAll('.js-highcharts-chart');
                        allChartElements.forEach(function(thisChartElement) {
                            thisChartElement.style.display = 'none';
                        });
                        targetChartElement.style.display = 'block';
                    });
                }

                window.highcharts11.push(chart);
            });
        });

        window.addEventListener('beforeprint', (event) => {
            window.highcharts11.forEach(function(chart, index) {
                chart.viewData();
                const chartWidth = chart.chartWidth;
                window.highcharts11Widths[index] = chartWidth;
                if (chartWidth > 720) {
                    chart.update({chart: {width: 720}}, true);
                }
            });
        });

        window.addEventListener('afterprint', (event) => {
            window.highcharts11.forEach(function(chart, index) {
                console.log(window.highcharts11Widths);
                const chartWidth = window.highcharts11Widths[index];
                chart.update({chart: {width: chartWidth}}, true);
                const dataTable = getClosest(chart.container, '.js-highcharts').querySelector('.highcharts-data-table');
                console.log(dataTable);
                if (dataTable) {
                    dataTable.parentNode.removeChild(dataTable);
                }
            });
        });

    });

}());
